import * as React from 'react';
import * as Styled from './CurrencyDisplay.styles';
import { useSettings } from '@innovyze/stylovyze/lib/contexts/Settings';
import { getCurrency } from '@innovyze/stylovyze/lib/utils/currency';
import useUnits from '@innovyze/stylovyze/lib/hooks/useUnits';
/**
 * Display metric value with unit in the correct unit system (metric/imperial)
 */
export const CurrencyDisplay = ({ value, cy, invalidValue, currency, precision, unit, extendedSymbol, }) => {
    const { companySettings } = useSettings();
    const { getSystemValueNoIntlFormat } = useUnits();
    let number = Number(value);
    if (unit) {
        number = parseFloat(getSystemValueNoIntlFormat(`${number} ${unit}`));
    }
    const displayValue = getCurrency(number, companySettings, currency, precision, extendedSymbol);
    return (React.createElement(Styled.Wrapper, { "data-cy": cy }, displayValue ? displayValue : invalidValue));
};
CurrencyDisplay.defaultProps = {};
export default CurrencyDisplay;
